// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"fa6c3d1d","436":"7611013a"}[chunkId] + ".chunk.css";
};